import React from 'react';
import { Button } from 'rebass';
import { FiSend } from 'react-icons/fi';

import { useResendOptInConfirmationEmailMutation } from 'api/useResendOptInConfirmationEmailMutation';
import { useToastHelper } from 'hooks/useToastHelper';
import services from 'services/services';

/**
 * @typedef {Object} ResendOptInConfirmationEmailButtonProps
 * @property {number} personId
 * @property {string} [className]
 * @property {React.CSSProperties} [style]
 */

/**
 * Resend opt-in confirmation email button.
 *
 * @param {ResendOptInConfirmationEmailButtonProps} props
 * @returns {React.ReactNode}
 */
export function ResendOptInConfirmationEmailButton({ personId, style, className }) {
    const { addSuccessToast, addErrorToast } = useToastHelper();
    const { mutate: resend, isLoading } = useResendOptInConfirmationEmailMutation({
        onSuccess: () => {
            addSuccessToast('Opt-in confirmation email resent');
        },
        onError: error => {
            const message = services.parseAndTrackXhrErrors(error);
            addErrorToast(message);
        }
    });

    return (
        <Button
            style={style}
            className={className}
            type="button"
            variant="secondary-gray"
            disabled={isLoading}
            onClick={() => resend(personId)}
        >
            <FiSend /> Resend Opt-In
        </Button>
    );
}
